export default {
  schooltypes: {
    'academic': 'Academic',
    'after_school_care': 'After School Core',
    "board_games": 'Board Games',
    "college": 'College',
    "college_prep": 'College Prop',
    "cooking": 'Cooking',
    "dance": 'Dance',
    "daycare_and_babysitting": 'Daycare and Babysitting',
    "events": 'Events',
    "fine_arts": 'Fine Arts',
    "fitness": 'Fitness',
    "languages": 'Languages',
    "martial_arts": 'Martial Arts',
    "math": 'Math',
    "music": 'Music',
    "outdoor_activities": 'Outdoor Activities',
    "performing_arts": 'Performing Arts',
    "photography_and_movie_making": 'Photography and Movie Making',
    "private_school": 'Private School',
    "programming": 'Programming',
    "public_school": 'Public School',
    "reading": 'Reading',
    "science": 'Science',
    "sports": 'Sports',
    "university": 'University'
  },
  settings: {
    'monthly': 'Monthly',
    'yearly': 'Yearly'
  }
}



// WEBPACK FOOTER //
// ./src/locale/translations/EN.js